import Icon from "@core-components/icon/Icon";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Button } from "@mantine/core";
import { openDiscordProps } from "../ButtonVariants";

interface Props {
  className?: string;
}

const JoinDiscord: React.FC<Props> = ({ className }) => {
  const { t } = useAppTranslation("components.joinDiscordButton");

  return (
    <Button
      className={`gradient-blue-light-purple rounded-lg bg-no-repeat font-inter font-medium text-primary-white text-sm hover:text-primary-white ${className}`}
      leftSection={<Icon.Discord size={20} />}
      size="md"
      {...openDiscordProps}
    >
      {t("text")}
    </Button>
  );
};

export default JoinDiscord;
